import {type Line} from '../../../util/plotHelpers/types';
import {type SeriesEntry} from './getSeriesEntries';

/** Summarize input work using array lengths and metadata, never point values. */
export function getUPlotTelemetryContext(
  lines: readonly Line[],
  seriesEntries: readonly (SeriesEntry | null)[]
) {
  let sourcePointCount = 0;
  let maxSourcePointCount = 0;
  let hasSmoothing = false;
  let hasGrouping = false;
  let dataMode: Line['meta']['mode'] | 'mixed' = lines[0]?.meta.mode ?? 'mixed';
  for (const line of lines) {
    const length = line.data.length;
    sourcePointCount += length;
    maxSourcePointCount = Math.max(maxSourcePointCount, length);
    hasSmoothing ||=
      line.smoothed === true || line.meta.category === 'smoothed';
    hasGrouping ||=
      line.meta.category === 'grouped' || (line.groupKeys?.length ?? 0) > 0;
    if (line.meta.mode !== dataMode) {
      dataMode = 'mixed';
    }
  }
  let bandCount = 0;
  for (const entry of seriesEntries) {
    if (entry?.type === 'band-min') {
      bandCount++;
    }
  }
  return {
    uPlotTelemetryVersion: 1,
    renderer: 'uplot' as const,
    // Preserve existing dashboard filters after removing the URL override.
    modeOverride: false,
    sourcePointCount,
    maxSourcePointCount,
    lineCount: lines.length,
    seriesCount: seriesEntries.length - 1,
    bandCount,
    hasSmoothing,
    hasGrouping,
    dataMode,
  };
}
